<template>
  <div class="endProfiles" :key="`tab_content_8` + $store.state.calculatorData.calculatorPages[8].disabled">
    <div class="row">
      <div class="col-md-7">
        <h2>{{ $t(`endProfiles.title`)}}</h2>
      </div>
      <div class="col-md-5 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>

    <b-button v-if="elementForm !== 'jaka'" @click="explanationClick()" v-b-toggle.explanation-content-endProfiles variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-endProfiles" class="explanation-content" :visible="elementForm === 'jaka'">
      <b-card>
        <p v-html="$t(`endProfiles.infoText`)"></p>
      </b-card>
    </b-collapse>
    <div >
      <div v-if="elementForm !== 'jaka'" class="wallProfiles">
        <h3>{{ $t(`wallProfiles.title`)}}:</h3>
        <p class="d-md-none font-size-small radio-info-text">
          <b-badge variant="warning">i</b-badge>
          Wählen für weitere Informationen
        </p>
        <div>
          <div class="radio-tile-group columns-2">
            <StoRadio step="wallProfiles" :type="`t_`+elementForm" :disabled="wallProfilDisabled('t') || elementForm === 'jaka'" />
            <StoRadio step="wallProfiles" :type="`uf_`+elementForm" :disabled="wallProfilDisabled('uf') || elementForm === 'jaka'" />
          </div>
        </div>
        <!-- <div class="info-wrapper">
          <p v-if="wallProfilAllDisabled()" class="info" v-html="$t(`endProfiles.infoText`)"></p>
        </div> -->

        <div class="slider-wrapper input-container calculated-box">
          <div class="col-md-6">
            <div class="row space-between highlight-box" :class="{ 'disabled': elementForm === 'jaka' }">
              <div class="col-md-8">
                <span v-html="$t(`variablesNice.w`)"></span>
                <p>W = B - E - H</p>
              </div>
              <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
                <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" :disabled="elementForm === 'jaka' || true"> mm
              </div>
              <div class="col-md-4 d-none d-md-block">
                <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" :disabled="elementForm === 'jaka' || true"> mm
              </div>
              <div v-if="$store.state.calculatorData.errors['w'] === 'min'" class="col-12 error">
                {{$tc(`elementWidths.werrorMin`, min, {min: calculatorMin.w()})}}
              </div>
              <div v-if="$store.state.calculatorData.errors['w'] === 'max'" class="col-12 error">
                {{$tc(`elementWidths.werrorMax`, max, {max: calculatorMax.w()})}}
              </div>
            </div>
          </div>
        </div>

        <div class="info-wrapper">
          <p v-if="!isBox" class="info" v-html="$t('wallProfiles.triggerInfo1')"></p>
          <div v-if="$store.state.calculatorData.warnings.endProfiles">
            <!-- <p v-if="$store.state.calculatorData.warnings.endProfiles.onlyT" class="info" v-html="$t('wallProfiles.triggerInfo2')"></p>
            <p v-if="$store.state.calculatorData.warnings.endProfiles.onlyT" class="info" v-html="$t('wallProfiles.triggerInfo3')"></p> -->
          </div>
          <!-- <p v-if="isBox" class="info" v-html="$t('wallProfiles.triggerInfo4')"></p> -->
        </div>
      </div>
      <div v-if="elementForm !== 'jaka'" class="stripColor highlight-box">
        <h3>{{ $t(`endProfiles.stripColor.title`)}}</h3>
        <div v-if="(elementForm === 'jasp') || (elementForm === 'jasa')">
          <div class="info-wrapper">
            <p class="info" v-html="$t('endProfiles.stripColor.triggerInfo1')"></p>
          </div>
        </div>
        <div v-else>
          <label class="radio-label" :class="{ 'disabled': elementForm === 'jaka' }">
            {{ $t(`endProfiles.stripColor.options.alu`)}}
            <input type="radio" :class="`${checkedProfilColorAlu}`" name="stripColor" value="alu" v-on:change="updateInput" @click="registerUserInput()" v-on:keyup="registerUserInput()" :disabled="elementForm === 'jaka'">
            <span class="checkmark"></span>
          </label>
          <label class="radio-label" :class="{ 'disabled': elementForm === 'jaka' }">
            {{ $t(`endProfiles.stripColor.options.white`)}}
            <input type="radio" :class="`${checkedProfilColorWhite}`" name="stripColor" value="white" v-on:change="updateInput" @click="registerUserInput()" v-on:keyup="registerUserInput()" :disabled="elementForm === 'jaka'">
            <span class="checkmark"></span>
          </label>

          <label class="radio-label ral-wrapper-label row" :key="$store.state.calculatorData.currentOrder.profilColor" :class="{ 'disabled': elementForm === 'jaka' }">
            <div class="col-md-4 col-flex">
              <div class="ral-wrapper-label-content">
                <span v-html="$t(`endProfiles.stripColor.options.special`)"></span>
                <input type="radio" :class="`${checkedProfilColorRal}`" name="stripColor" v-on:change="updateInput" :disabled="elementForm === 'jaka'">
                <span class="checkmark"></span>
              </div>
            </div>
            <div class="col-md-8">
              <RALSelection :disabled="elementForm === 'jaka'" />
            </div>
          </label>

          <div v-if="(elementForm === 'jak')">
            <div class="info-wrapper">
              <p class="info" v-html="$t('endProfiles.stripColor.triggerInfo2')"></p>
            </div>
          </div>
          <div v-if="(elementForm === 'jas')">
            <div class="info-wrapper">
              <p class="info" v-html="$t('endProfiles.stripColor.triggerInfo3')"></p>
            </div>
          </div>
          <div v-if="((elementForm === 'jakp') || (elementForm === 'jaka'))">
            <div class="info-wrapper">
              <p class="info" v-html="$t('endProfiles.stripColor.triggerInfo4')"></p>
            </div>
          </div>

        </div>

      </div>

      <div class="dripEdgeProfile">
        <h3>{{ $t(`dripEdgeProfile.title`)}}:</h3>
        <p class="d-md-none font-size-small radio-info-text">
          <b-badge variant="warning">i</b-badge>
          Wählen für weitere Informationen
        </p>
        <div class="radio-tile-group columns-3">
          <StoRadio step="dripEdgeProfile" :type="`3`" :disabled="dripEdgeProfileDisabled(3)" />
          <StoRadio step="dripEdgeProfile" :type="`6`" :disabled="dripEdgeProfileDisabled(6)" />
          <StoRadio step="dripEdgeProfile" :type="`10`" :disabled="dripEdgeProfileDisabled(10)" />
        </div>
        <!-- <div v-if="(this.elementForm === 'jas' || this.elementForm === 'jak')" class="info-wrapper">
          <p class="info" v-html="$t('endProfiles.dripEdgeProfile.notAvailable')"></p>
        </div> -->
      </div>

    </div>
    <StepNavi thisPage="7" :key="`navi_tab7_`+ $store.state.calculatorData.calculatorPages[7].allFieldsUpdated"/>
  </div>
</template>

<script>
import StoRadio from './StoRadio.vue'
import StepNavi from './StepNavi.vue'
import RALSelection from './RALSelection.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'EndProfiles',
  components: {
    StoRadio,
    StepNavi,
    RALSelection
  },
  data () {
    return {
      max: 0,
      min: 0,
      textTriggerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'isBox',
      'elementForm',
      'h',
      'w'
    ]),
    checkedProfilColorAlu: function () {
      let isChecked = ''
      if (this.$store.state.calculatorData.currentOrder.profilColor === 'alu') {
        isChecked = 'checked'
      }
      return isChecked
    },
    checkedProfilColorWhite: function () {
      let isChecked = ''
      if (this.$store.state.calculatorData.currentOrder.profilColor === 'white') {
        isChecked = 'checked'
      }
      return isChecked
    },
    checkedProfilColorRal: function () {
      let isChecked = ''
      if ((this.$store.state.calculatorData.currentOrder.profilColor !== '') && (this.$store.state.calculatorData.currentOrder.profilColor !== 'white') && (this.$store.state.calculatorData.currentOrder.profilColor !== 'alu')) {
        isChecked = 'checked'
      }
      return isChecked
    }
  },
  methods: {
    registerUserInput: function () {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true
    },
    updateInput: function (event) {
      const payload = {
        key: 'profilColor',
        value: event.target.value,
        validate: true
      }
      this.$store.dispatch('didInputFkt', payload)

      if (this.$store.state.calculatorData.currentOrder.profilColor === 'alu') {
        this.tracking(this.$t('endProfiles.stripColor.options.' + this.$store.state.calculatorData.currentOrder.profilColor))
      }
      if (this.$store.state.calculatorData.currentOrder.profilColor === 'white') {
        this.tracking(this.$t('endProfiles.stripColor.options.' + this.$store.state.calculatorData.currentOrder.profilColor))
      }
    },
    tracking: function (value) {
      let gtmEvent = 'JKK-Events'
      let gtmEventCategory = 'Farbauswahl Abschlussleisten'
      let gtmEventAction = 'Radio'
      let gtmEventLabel = value
      let virtualPageURL = '/profile'
      let virtualPageTitle = 'Profile'
      this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
    },
    wallProfilDisabled: function (profilTyp) {
      // false = Element is enabled and clickable
      // true = Element is disabled. Not clickable

      /*
        conditions for Profiles
        w (ab 20 <30) => only UF Profile
        w (30 <= => 60) UF and T Profile
        w (>60 ) only T
      */
      /*
        conditions for Profiles
        20, 30, 40, 50 und 60 mm
      */

      const availableProfilWidths = [ 20, 30, 40, 50, 60 ]

      if (availableProfilWidths.includes(this.$store.state.calculatorData.currentOrder.w) && (profilTyp === 'uf')) {
        return false
      }

      if ((this.$store.state.calculatorData.currentOrder.w > 30) && (profilTyp === 't')) {
        return false
      }

      return true
    },
    wallProfilAllDisabled: function () {
      if (this.wallProfilDisabled('u') && this.wallProfilDisabled('t') && this.wallProfilDisabled('f')) {
        return true
      }
      return false
    },
    dripEdgeProfileDisabled: function (dripEdgeWidth) {
      const currentNotAvailable = []
      if ((this.elementForm === 'jas' || this.elementForm === 'jak') && currentNotAvailable.includes(dripEdgeWidth)) {
        return true
      }
      return false
    },
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'endProfiles'
        let gtmEventLabel = this.$t(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- EndProfiles rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
